export default __webpack_public_path__ + "static/media/YAS0920.34I-42439_-25426_0.625e84ca.jpg";